/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>待付款</public-title>
    <div class="bg-white load-area">
        <div class="d-center-between flex-wrap">
            <left-text-border class="w-45 mb-3" leftText="订单号" v-model="searchData.oid" @enter="confirmSearch"/>
            <left-text-select class="w-45 mb-3" leftText="门店类型" :options="$GVAR.StoreTypeGro " v-model="searchData.store_type" />
            <left-text-autocomplete  class="w-45 mb-3" leftText="门店名称" v-model="searchData.title"  @enter="confirmSearch" :storeType="3"/>
            <left-text-border class="w-45 mb-3" leftText="门店ID"  v-model="searchData.store_id" @enter="confirmSearch"/>
            <left-text-border class="w-45 mb-3" leftText="银行卡号" v-model="searchData.bank_card" @enter="confirmSearch"/>
            <left-text-border class="w-45 mb-3" leftText="银行账户" v-model="searchData.truename" @enter="confirmSearch"/>
            <div class="w-45 mb-3 d-center-start" >
              <el-select v-model="timeType" placeholder="时间查询" size="small" class="mr-1" style="width:260px;">
                <el-option v-for="item in timeChoose" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
              <el-date-picker v-model="timestamp" type="daterange" class="w-100" size="small"
                      v-show="$GFUN.isInArray(['timeFrame','postTime','dealTime'],timeType)"
                      range-separator="至" value-format="timestamp" start-placeholder="开始时间"
                      end-placeholder="结束时间" />
              <el-date-picker type="date" v-model="timetime" class="w-100" size="small" 
                              v-show="timeType === 'timeArr'" placeholder="可选择一个日期"/>
            </div>
        </div>
        <div class="d-center-between mb-3">
            <div class="text-left ml-2 text-blue totals">
              <p>统计:</p>
              <p>平台收款：{{AdminDataLists.info.total.price_pay_total /100 | formatMoney}} 元</p>
              <p>手续费：{{AdminDataLists.info.total.app_charge_total /100 | formatMoney}} 元</p>
              <p>付自由行：{{AdminDataLists.info.total.offset_price_pay_total /100 | formatMoney}} 元</p>
              <p>订单金额：{{AdminDataLists.info.total.payment_pay_total /100 | formatMoney}} 元</p>
              <p>酒店佣金：{{AdminDataLists.info.total.charge_total /100 | formatMoney}} 元</p>
              <p>实际待打款金额：{{AdminDataLists.info.total.fact_payment_pay_total /100 | formatMoney}} 元</p>
            </div>
            <el-button type="success" size="small" @click="loadTable" class="loadTable">下载表单</el-button>
            <el-button type="primary" size="small" @click="confirmSearch">搜索</el-button>
        </div>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else class="el-tables">
        <template>
          <el-table
            :data="AdminDataLists.lists"
            :summary-method="getSummaries"
             show-summary
            border
            stripe
            max-height="780"
            style="width: 100%">
            <!--表单内容-->
            <el-table-column v-for="(item,index) in fundsForm" :key="index" :prop="item.prop" :label="item.name" :width="item.width" :min-width="item.minWidth" header-align="center">
              <!-- 自定义表头 -->
              <template slot="header" slot-scope="scope">
                <span>{{ scope.column.label }}</span>
                <!-- <p v-if="item.total">{{ AdminDataLists.info.total[item.total] /100 | formatMoney}}</p> -->
              </template>
              <template slot-scope="scope">
                <!--订单号-->
                <div class="cursor-pointer pointers" :class="{'text-center':item.center}" v-if="item.pattern==='oid'" @click="goHotelDetail(scope.row)">{{ scope.row[item.prop]}}</div>
                <!--时间-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='time'">{{ scope.row[item.prop]| formatTimestamp(5)}}</div>
                <!--金额-->
                <div :class="{'text-center':item.center}" v-else-if="item.pattern==='money'">{{ scope.row[item.prop]/100 | formatMoney}}<div class="price_pay" v-if="item.prop=='price_pay'&&scope.row.broker==1">(代订收款)</div></div>
                <!--状态-->
                <div class="red" :class="{'text-center':item.center}" v-else-if="item.pattern==='status'">{{ scope.row[item.prop]| formatVar('orderstatus')}}</div>
                <!--其他-->
                <div :class="{'text-center':item.center}" v-else>{{ scope.row[item.prop]}}</div>
              </template>
            </el-table-column>
            <!--操作按钮-->
            <el-table-column
              fixed="right"
              header-align="center"
              label="操作"
              width="100">
              <template slot-scope="scope">
                <el-dropdown @command="handleCommand($event,scope.row)">
                  <el-button  class="el-dropdown-link text-link" type="text" size="small" style="margin: 0 auto; display: block;">查看<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  command="1">打款</el-dropdown-item>
                    <el-dropdown-item  command="2">{{userLoginMessage.id==scope.row.submit_uid?'撤销提交':'驳回'}}</el-dropdown-item>
                    <el-dropdown-item  command="3" >修改手续费</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button @click="informUser(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">打款</el-button>
                <el-button @click="revoke(scope.row)" type="text" size="small" style="margin: 0 auto; display: block;">{{userLoginMessage.id==scope.row.submit_uid?'撤销提交':'驳回'}}</el-button>
                <el-button @click="financeprice(scope.row)"  type="text" size="small" style="margin: 0 auto; display: block;">修改手续费</el-button> -->
                <!-- <el-dropdown-item  command="2" >撤销提交</el-dropdown-item>
                <el-dropdown-item  command="3"  >修改手续费</el-dropdown-item> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next, sizes" class="mt-4" :page-sizes="[10,15,20,30]" :page-size="Formdata.num" @size-change="handleSizeChange"
                       :total="AdminDataLists.total" :current-page="Number(Formdata.page)" @current-change="handleCurrentChange"/>
        </template>
      </div>
    </div>
    <el-dialog title="确认打款" :visible.sync="dialogFormVisible" width="20%" class="paymentist" :close-on-click-modal="false">
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="订单号"/><span v-html="currentItem.oid"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="门店类型"/><span>{{currentItem.store_type | formatVar('StoreType')}}</span>
        </div>
        <div class="d-center-start w-100 mb-3" v-for="item in showDetailArr" :key="item.name">
            <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="待打款金额"/><span >{{currentItem.payment_pay/100 | formatMoney}}元</span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="手续费"/><span >{{currentItem.charge/100| formatMoney}}元</span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="实际打款金额"/><span class="red" >{{currentItem.fact_payment_pay/100| formatMoney}}元</span>
        </div>
        <div class="d-center-start w-100 mb-3">
            <left-text leftText="打款备注"/><span class="blues">{{currentItem.remark?currentItem.remark:'无'}}</span>
        </div>
        <!-- <div class=" name">订单号:{{ruleForm.oid}}</div>
        <div class=" name">所属酒店:{{hotel_title}}</div> -->
        <el-form :model="ruleForm" :rules="region" ref="ruleForm" label-width="90px" class="demo-ruleForm" label-position="top" size="small" >
            <el-form-item label="回单号" prop="receipt_no" class="lie">
              <el-input v-model="ruleForm.receipt_no" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="备注" class="lie">
                <el-input type="text" v-model="ruleForm.remark"  maxlength="20" show-word-limit></el-input>
            </el-form-item>
        </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
      <el-dialog title="修改手续费" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission v-if="finance" :remark="remark" @finance="finance=!finance" :modify="modify" :price_pay="price_pay" @submitFinance="submitFinance"></commission>
      </el-dialog>
  </div>
</template>
<script>
  import { mapGetters, mapActions,mapState } from 'vuex'
  import commission from './Subassembly/commission.vue'
  export default {
    name: 'PaymentList',
    components: {commission},
    computed: {
      ...mapState(['AdminDataLists','userLoginMessage']),
      ...mapGetters(['storeInfo']),
      //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      titleArr() {
        let arr = ['订单号','门店名称','门店账户','平台收款','手续费(元)','付自由行(元)','订单金额(元)','酒店佣金(元)','实际待打款金额(元)','提交人','提交时间','状态','操作'];
        for(let i in arr){
          arr[i]=arr[i].replace(/\n/g, '<br/>')
        }
        return arr;
      },
      timeChoose() {
        let arr =  [
          {name:`提交时间`,value:'timeArr'},
          {name:`按时间段`,value:'timeFrame'},
        ];
        return arr
      },
    },
    created() { 
      // 读取本地缓存
      const cache = JSON.parse(localStorage.getItem('paymentSearchCache') || '{}');
      if (this.$route.query) this.Formdata.page = Number(this.$route.query.page||1);
      // 有缓存就回填表单
      if (cache.num) this.Formdata.num = Number(cache.num);
      this.getDataLists(); 
    },
    data() {
      return {
        fundsForm:[
          {name:'订单号',prop:'oid',center:true,width:150,pattern:'oid'},
          {name:'门店名称',prop:'title',minWidth:200},
          {name:'银行账户',prop:'truename',minWidth:200},
          {name:'平台收款(元)',prop:'price_pay',center:true,width:150,pattern:'money'},
          {name:'手续费(元)',prop:'app_charge',center:true,width:150,pattern:'money'},
          {name:'付自由行(元)',prop:'offset_price_pay',center:true,width:150,pattern:'money'},
          {name:'订单金额(元)',prop:'payment_pay',center:true,width:150,pattern:'money'},
          {name:'酒店佣金(元)',prop:'charge',center:true,width:150,pattern:'money'},
          {name:'实际待打款金额(元)',prop:'fact_payment_pay',center:true,width:150,pattern:'money'},
          {name:'提交人',prop:'submit_name',center:true,width:120},
          {name:'提交时间',prop:'add_time',center:true,width:180,pattern:'time'},
          {name:'状态',prop:'status',center:true,width:120,pattern:'status'},
        ],
        finance:false,
        radio1:'1',
        dialogFormVisible:false,
        formLabelWidth:'120px',
        ruleForm: {
          receipt_no: '',
          remark:'',
        },
        region: {
            receipt_no: [
                { required: true, message: '请输入回单号', trigger: 'blur' },
            ],
        },
        showDetailArr:[
          {name:'银行卡所属',value:'truename'},{name:'开户银行',value:'bank_name'},{name:'支行名称',value:'branch'},{name:'银行卡号',value:'bank_card'}
        ],
        truename:'',
        timeType:'timeArr',
        timestamp: [],
        hotel_title:'',
        showDetail:false,
        currentItem:{},     
        out_trade_no:'',
        is_merge:false,
        Formdata:{
            num:10,                                //每页显示条数
            page:1,                               //当前页
        },
        searchData:{
            title:'',                              //门店名称
            truename:'',                           //银行账户
            oid:'',                                //订单ID
            store_type:0,                          //门店类型
            store_id:'',                           //门店ID
            bank_card:'',                          //银行卡号
            add_time:''                            //按时间
        },
        state:'',
        timetime:'',
        price_pay:0,
        modify:0,
        pay_id:0,
        remark:'',
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSetInvoice','adminPayment','adminPaymentRevoke','getWaitHandleData','adminSubmitModify','POST_Admin_DownloadForm']),
        //确认搜索
        confirmSearch(){
    
          this.Formdata.page=1;
          this.getDataLists();
        },
        //订单详情页
        goHotelDetail (e) {
            let cardItem=e;
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: 3,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
      },
      //设置分页数量
      handleSizeChange(val) {
        this.Formdata.num = val;
        this.Formdata.page=1;
        this.updateQuery({ num: val,page:1})
        this.getDataLists();
      },
      //设置当前页
      handleCurrentChange(val) {
        // 把参数存进路由地址栏，页面不动
        this.Formdata.page = val;
        this.updateQuery({ page: val });
        this.getDataLists();
      },
      // 统一更新路由方法
      updateQuery(query) {
        this.$router.replace({
          query: { ...this.$route.query, ...query }
        });
        // 2. 存入本地存储
        let cache = JSON.parse(localStorage.getItem('paymentSearchCache') || '{}')
        localStorage.setItem('paymentSearchCache', JSON.stringify({ ...cache, ...query }))
      },
      //底部合计
      getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '小计';
                return;
              }
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value))&&column.property!='add_time'&&column.property!='status') {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index] = (sums[index]/100).toFixed(2);
              } else {
                sums[index] = '';
              }
            });
            console.log(sums);
            return sums;
          },
      //点击打款
      informUser(item) {
        console.log(item)
        this.ruleForm.pay_id = item.pay_id;
        this.ruleForm.remark = '';
        this.ruleForm.receipt_no = '';
        this.currentItem = item;
        this.dialogFormVisible = true;
      },
      //点击操作按钮
      handleCommand(command,Itemize) {
        let htis = this;
        switch (command) {
          case '1':
            this.informUser(Itemize);
            break
          case '2':
            this.revoke(Itemize);
            break
          case '3':
            this.financeprice(Itemize);
            break
        }
      },
      //打款
      submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.adminPayment({
                  data:this.ruleForm,
                  successFun: () => {
                      this.getDataLists();
                      this.getWaitHandleData();
                      this._alert('提交成功');
                      this.dialogFormVisible = false;
                  }
              }); 
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
      },
      //撤销提交
      revoke(formName){
        let pay_id={pay_id:formName.pay_id}
        this.adminPaymentRevoke({
            data:pay_id,
            successFun: () => {
                this.getDataLists();
                this.getWaitHandleData();
                this._alert('撤销成功');
                this.dialogFormVisible = false;
            }
        }); 
      },
      //获取交易记录列表
      async getDataLists() {
         await this.getAdminDataLists({
            data:this.getSearchForm(),
            type:'PaymentList',
        });
        // this.totalPayMoney = resInfo.total_pay_money || 0;
        // this.totalEndMoney = resInfo.total_end_money || 0;
      },
      //获取搜索表单
      getSearchForm() {
        let data={
          ...this.Formdata,
          ...this.searchData
        };
        let start = this.timestamp && this.timestamp.length > 0 ? this.timestamp[0] / 1000 : '';
        let end = this.timestamp && this.timestamp.length > 0 ? this.timestamp[1] / 1000 + 86399 : '';
        switch (this.timeType) {
          case 'timeArr':
           let timeArr = this.timetime?this.timetime.getTime() / 1000:'';
            data.add_time = timeArr;
            break;
          case 'timeFrame':
            data.add_time = start?start+','+end:'';
            break;
        }
        return data;
      },
      /**
       * 手续费最大值
       */
        financeprice(res){
          this.finance=true;
          this.price_pay=res.payment_pay/100;
          this.modify=res.charge/100;
          this.pay_id = res.pay_id;
          this.remark=res.remark;
        },
        /**
         * 管理员提交财务
         */
        submitFinance(ruleForm){
              this.finance=!this.finance;
              ruleForm.pay_id=this.pay_id;
              delete ruleForm.numerical_value;
              this.adminSubmitModify({
                data:ruleForm,
                successFun: () => {
                    this.getDataLists();
                    this._alert('修改打款信息成功');
                }
              });
        },
      //待付款下载表单
      loadTable(){
        this.POST_Admin_DownloadForm({data:this.getSearchForm(),type:1})
      },
    }
  }
</script>
<style lang="css" scoped>
   .pointers:hover{
    color: var(--smtc-color-primary); 
  }
  .commission{
    display: flex;
    justify-content: space-between;
  }
  .refund_fee{
    font-size: 13px;
    margin-top: 2px;
    color:brown;
  }
  .list-item-col{
    white-space: pre-line;
  }
  .name{
      text-align: left;
  }
  .lie{
    margin-right: 16px;
  }
  .demo-ruleForm{
    width: 96%;
    margin: 0 auto;
  }
  .cops-text{
    opacity: 0;
  }
  .goHotelDetail{
    cursor: pointer;

  }
  .goHotelDetail:hover{
    color: var(--smtc-color-primary); 
  }
  .blues{
    color: #1d1dcc;
  }
  .tablePagination{
      margin-top: 20px;
      display: flex;
      justify-content: end;
  }
  .totals{
    display: flex;

  } 
  .totals p{
      border-left: 1px #eee solid;
      padding: 0 10px;
      color: #666;
  }
  .totals p:nth-child(1),
  .totals p:nth-child(2) {
    border-left: none;
    padding-left: 0;
  }
  .price_pay{
    font-size: 12px;
    color: var(--smtc-color-primary);
  }
  .loadTable{
    margin-left: auto;
  }
  .el-tables .el-dropdown{
    width: 100%;
  }
  </style>